// extracted by mini-css-extract-plugin
module.exports = {"root":"_4f720283bf--root--JAO_T","price":"_4f720283bf--price--Bz6tl"};